import React from 'react';
import {
    AdminGuard,
    GuestGuard,
    PartnerAgentGuard,
    PartnerGuard,
    SaloonWorldGuard,
} from '../guards/RolesGuard';
import Register from '../features/auth/register';
import Login from "../features/auth/login";
import Layout from '../container/Layout';
import Profile from '../features/dashboard/profile';
import ResetPassword from '../features/auth/reset-password';
import PurchaseOrder from '../features/dashboard/purchases';
import Users from '../features/admin-dashboard/users';
import Callback from '../features/dashboard/callback/Callback';
import Settings from '../features/dashboard/settings/Settings';
import Reconciliation from '../features/dashboard/reconciliation';
import Agents from '../features/dashboard/agents';
import Integrations from '../features/dashboard/settings/integrations';
import Clients from '../features/dashboard/clients';
import XeroCallback from '../features/dashboard/callback/XeroCallback';
import InvitedPartners from '../features/admin-dashboard/users/invited-partners';
import AccountReceivable from '../features/dashboard/invoices/account-receivable';
import AccountPayable from '../features/dashboard/invoices/account-payable';
import AgentActivities from '../features/dashboard/agent-activities';


export interface RouteDefinition {
    path: string;
    element: JSX.Element;
    guard?: () => boolean;
    index?: string,
    childrens?: RouteDefinition[];
}

export const routes: RouteDefinition[] = [
    // Guest pages should have GuestGuard so everyone can access
    {
        path: '/login',
        element: <Login />,
        guard: GuestGuard,
    },
    {
        path: '/register/:id',
        element: <Register />,
        guard: GuestGuard,
    },
    {
        path: '/reset-password',
        element: <ResetPassword />,
        guard: GuestGuard,
    },
    // Admin pages should have AdminGuard
    {
        path: '/users',
        element: <Layout />,
        index: '/users',
        guard: AdminGuard,
        childrens: [
            {
                path: '',
                element: <Users />
            },
            {
                path: 'invited',
                element: <InvitedPartners />
            },
        ],
    },
    // Brokers/Partners should have PartnerAgentGuard for each different role user should be a guard
    {
        path: '/purchase-orders',
        element: <Layout />,
        index: '/purchase-orders',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <PurchaseOrder />
            },
        ],
    },
    {
        path: '/account-receivable',
        element: <Layout />,
        index: '/account-receivable',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <AccountReceivable />
            },
        ],
    },
    {
        path: '/account-payable',
        element: <Layout />,
        index: '/account-payable',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <AccountPayable />
            },
        ],
    },
    {
        path: '/ai-agent-activities',
        element: <Layout />,
        index: '/ai-agent-activities',
        guard: PartnerGuard,
        childrens: [
            {
                path: '',
                element: <AgentActivities />
            },
        ],
    },
    {
        path: '/reconciliations',
        element: <Layout />,
        index: '/reconciliations',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <Reconciliation />
            },
        ],
    },
    {
        path: '/clients',
        element: <Layout />,
        index: '/clients',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <Clients />
            },
        ],
    },
    {
        path: '/members',
        element: <Layout />,
        index: '/members',
        guard: PartnerGuard,
        childrens: [
            {
                path: '',
                element: <Agents />
            },
        ],
    },
    {
        path: '/settings',
        element: <Layout />,
        index: '/settings',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <Settings />
            },
            {
                path: 'integrations',
                element: <Integrations />
            }
        ],
    },
    {
        path: '/profile',
        element: <Layout />,
        index: '/profile',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <Profile />
            }
        ],
    },
    {
        path: 'outlook-callback',
        element: <Layout />,
        index: '',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <Callback />
            }
        ],
    },
    {
        path: 'xero-callback',
        element: <Layout />,
        index: '',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <XeroCallback />
            }
        ],
    },
];